const VideoPrefix = "https://storage.googleapis.com/documentario-videos/videos/";
export default VideoPrefix;
